// Logs plugin.
import { logManager } from '../index'
import { logLevels } from 'kandy-logger/src/constants'
// Action specific.
import setupTransformers from './transformers'
import { titleFormatter } from './utils'

// Libraries.
import { createLogger } from 'redux-logger'

/**
 * Creates a redux middleware for logging actions.
 * @method createActionLogger
 * @param  {Object}     options
 * @return {Middleware}
 */
export default function createActionLogger (options) {
  // Create a Logger for handling the action logs.
  const logger = logManager.getLogger('ACTION')
  logger.setHandler(options.logActions.handler)
  logger.setLevel(options.logActions.level)

  const setLevel = logLevels[options.logLevel]

  let actionOptions = {}
  // Use different options for redux-logger depending on log level.
  if (setLevel === logLevels.INFO) {
    // At the INFO level, hide everything except the action name.
    actionOptions.level = false
    actionOptions.diff = false
  } else {
    // At the DEBUG+ levels, use the configs.
    actionOptions = {
      ...options.logActions
    }
  }

  if (options.logActions.actionOnly) {
    // Hide prevState and nextState.
    // Log action and error at info level, so the browser won't hide it by default.
    actionOptions.level = {
      prevState: false,
      action: 'info',
      error: 'info',
      nextState: false
    }
  }

  if (options.logActions.excludeActions) {
    actionOptions.predicate = excludeActions(options.logActions.excludeActions)
  }

  // ALWAYS use our own logger
  actionOptions.logger = logger
  // ALWAYS remove theming/styling from the action log messages
  actionOptions.titleFormatter = titleFormatter
  actionOptions.colors = false

  // Setup the transformers based on the options.
  const transformers = setupTransformers(options.logActions)
  // Create the logger middleware.

  return createLogger({
    ...actionOptions,
    ...transformers
  })
}

/**
 * Logger predicate function that will take an array of action types
 * and exclude them from logs
 * @param {Array} actions An array of action types to exclude from logs
 * @returns {function} A predicate function
 */
function excludeActions (actions) {
  return (getState, action) => !actions.includes(action.type)
}
